import { GroupeIndividu } from "./GroupeIndividu"
import { PaletteDocument } from "./PaletteDocument"
import { TarifActiviteDocument } from "./TarifActiviteDocument"
import { TarifEventSchedulerActiviteDocument } from "./TarifEventSchedulerActiviteDocument"

export class FiltrePointage {
    private listTemps: Array<TarifEventSchedulerActiviteDocument>;
    private palettepresence: Array<PaletteDocument>;
    private paletteabsence: Array<PaletteDocument>;
    private listGroupes: Array<GroupeIndividu>;
    private listSuppplements: Array<TarifActiviteDocument>;

    public constructor() {
        this.listTemps = new Array();
        this.palettepresence = new Array();
        this.paletteabsence = new Array();
        this.listGroupes = new Array();
        this.listSuppplements = new Array();
    }

    public getListTemps(): Array<TarifEventSchedulerActiviteDocument> {
        return this.listTemps;
    }

    public setListTemps(listTemps: Array<TarifEventSchedulerActiviteDocument>): void {
        this.listTemps = listTemps;
    }

    public getPalettepresence(): Array<PaletteDocument> {
        return this.palettepresence;
    }

    public setPalettepresence(palettepresence: Array<PaletteDocument>): void {
        this.palettepresence = palettepresence;
    }

    public getPaletteabsence(): Array<PaletteDocument> {
        return this.paletteabsence;
    }

    public setPaletteabsence(paletteabsence: Array<PaletteDocument>): void {
        this.paletteabsence = paletteabsence;
    }

    public getListGroupes(): Array<GroupeIndividu> {
        return this.listGroupes;
    }

    public setListGroupes(listGroupes: Array<GroupeIndividu>): void {
        this.listGroupes = listGroupes;
    }

    public getListSuppplements(): Array<TarifActiviteDocument> {
        return this.listSuppplements;
    }

    public setListSuppplements(listSuppplements: Array<TarifActiviteDocument>): void {
        this.listSuppplements = listSuppplements;
    }
}